import {Pipe, PipeTransform} from '@angular/core';
import {DateTime} from "luxon";

@Pipe({
  name: 'addDays'
})
export class AddDaysPipe implements PipeTransform {
  transform(date: Date, days: number): Date {
    const dateTime = DateTime.fromJSDate(date);
    return dateTime.plus({day: days}).toJSDate();
  }
}
